import { useQuery } from "@tanstack/react-query";
import { EmployeeService } from "../services/employee/employee.service";
import { IEmployee } from "../models";
import { useCallback } from "react";

export enum TitleCode {
  GD = "GD",
}

export const useEmployees = () => {
  const query = useQuery<Array<IEmployee>>({
    queryKey: ["employees"],
    queryFn: () => EmployeeService.getEmployees(),
  });

  const getTSNEmployees = useCallback(() => {
    if (!query?.data) return {};
    const TSN_TGD = query.data.find((i) => i.eLocation === "VTSN" && i.eBizTitleCode === "TGD") as IEmployee;
    const TSN_GD = query.data.find((i) => i.eLocation === "VTSN" && i.eBizTitleCode === "GD") as IEmployee;
    const TSN_PVHK_TTT = query.data.find((i) => {
      return i.eLocation === "VTSN" && i.eBizTitleCode === "TP" && i.eDepartmentCode === "PVHK1";
    }) as IEmployee;
    const TSN_PVSD_TTT = query.data.find((i) => {
      return i.eLocation === "VTSN" && i.eBizTitleCode === "TP" && i.eDepartmentCode === "PSC1";
    }) as IEmployee;

    const TSN_TP_KHHC = query.data.find(
      (i) => i.eLocation === "VTSN" && i.eBizTitleCode === "TP" && i.eDepartmentCode === "AP1",
    ) as IEmployee;

    const TSN_TCNL = query.data.find(
      (i) => i.eLocation === "TSN" && i.eBizTitleCode === "TP" && i.eDepartmentCode === "OAP",
    ) as IEmployee;
    return { TSN_GD, TSN_TGD, TSN_PVHK_TTT, TSN_PVSD_TTT, TSN_TP_KHHC, TSN_TCNL };
  }, [query?.data]);

  const getNBAEmployees = useCallback(() => {
    if (!query?.data) return {};
    const NBA_GD = query.data.find((i) => i.eLocation === "VNBA" && i.eBizTitleCode === "GD") as IEmployee;
    const NBA_TP_TTT = query.data.find((i) => {
      return i.eLocation === "VNBA" && i.eBizTitleCode === "TP";
    }) as IEmployee;

    return { NBA_GD, NBA_TP_TTT };
  }, [query?.data]);

  const getDADEmployees = useCallback(() => {
    if (!query?.data) return {};
    const DAD_GD = query.data.find((i) => i.eLocation === "VDAD" && i.eBizTitleCode === "GD") as IEmployee;
    const DAD_TP_TTT = query.data.find((i) => {
      return i.eLocation === "VDAD" && i.eBizTitleCode === "TP";
    }) as IEmployee;

    const DAD_TP_KHHC = query.data.find(
      (i) => i.eLocation === "VDAD" && i.eBizTitleCode === "TP" && i.eDepartmentCode === "AP3",
    ) as IEmployee;

    return { DAD_GD, DAD_TP_TTT, DAD_TP_KHHC };
  }, [query?.data]);

  const getEmployeeByTitleCode = (titleCode: string) => {
    if (!query?.data) return {} as IEmployee;
    return query.data.find((i) => i.eBizTitleCode === titleCode) as IEmployee;
  };

  return {
    ...query,
    employees: { ...getTSNEmployees() },
    NBAEmployees: { ...getNBAEmployees() },
    DADEmployee: { ...getDADEmployees() },
    getEmployeeByTitleCode,
  };
};
